<template>
  <div class="interest_form">
    <header class="header">
      <h3>
        <span>利益演示</span>
        <span
          v-if="isShowSettingButton"
          class="setting-btn"
          data-stat-id="lyxsxsx"
          :data-stat-ep="JSON.stringify({
            type: settingStore.displayType
          })"
          @click="$emit('update', { isShowFieldPopup: true })"
        >
          <i class="iconfont icon-screen" />
          <em>设置</em>
        </span>
      </h3>
      <div class="show_type">
        <div class="container">
          <span
            v-for="o in DISPLAY_TYPE_OPTIONS"
            :key="o.key"
            :class="{
              active: o.key === settingStore.displayType
            }"
            data-stat-id="lyqh"
            :data-stat-ep="JSON.stringify({
              key: o.key
            })"
            @click="$emit('update', {
              displayType: o.key
            })"
          >
            <i :class="['iconfont', o.icon]" />
            <em>{{ o.name }}</em>
          </span>
        </div>
      </div>
    </header>
    <header v-if="isScreenCaptureShow && isShowHeaderFixed" class="header_fixed">
      <span
        v-for="o in DISPLAY_TYPE_OPTIONS"
        :key="o.key"
        :class="{
          active: o.key === settingStore.displayType
        }"
        @click="$emit('update', {
          displayType: o.key
        })"
      >{{ o.name }}</span>
    </header>
    <section class="main">
      <ul v-if="interestDemoOptions" class="conditions">
        <li v-for="item in interestDemoOptions" :key="item.key" class="condition">
          <div class="left">
            {{ item.name }}
          </div>
          <div class="right">
            <div>
              <template v-for="o in item.options">
                <span
                  v-if="!o.hiddenFlag"
                  :key="o.value + (o.index || 0)"
                  class="option-pill"
                  :class="{
                    active: isActiveOption(item, o)
                  }"
                  :data-stat-id="item.stat"
                  :data-stat-ep="JSON.stringify({ key: o.value })"
                  @click="onClickItem(item, o)"
                >{{ o.description }}</span>
              </template>
            </div>
            <!-- data-stat-ep {key: -1} 是保持 WYJHS-959 修改前的逻辑，即"设置X"入口传入 -1 -->
            <div
              v-if="item.actionBtnTx"
              class="link-btn"
              :data-stat-id="item.stat"
              :data-stat-ep="JSON.stringify({ key: -1 })"
              @click="openItemSetting(item)"
            >
              {{ item.actionBtnTx }} <i class="iconfont icon-arrows_right" />
            </div>
            <template v-if="item.key==='bonus'&&formData.formValues.bonus==='PSUDO_OPTION_CUSTOM_RATE'&&!isTerminalC&&isShowBonusSetting">
              <InterestFormBonus
                :form-data="formData"
                :setting-name="'设置实现率'"
                :type="'bonus'"
                :step="1"
                :previous-bonus-custom-rate="Number(bonusCustomRate)"
                :max-bonus-custom-rate="maxBonusCustomRate"
                @update="data => updateBonusRate(item, data)"
              />
            </template>

            <!-- 当没有年金领取选项时，在红利领取后面显示组件 -->
            <template v-if="item.key==='bonusTake' && shouldShowBonusComponent && !hasPensionTake">
              <InterestFormBonus
                :form-data="formData"
                :setting-name="'设置利率'"
                :type="'acc'"
                :step="0.1"
                :previous-bonus-custom-rate="Number(accRate)"
                :max-bonus-custom-rate="5"
                @update="data => updateAccRate(data)"
              />
            </template>

            <!-- 在年金领取后面显示组件 -->
            <template v-if="item.key==='pensionTake' && shouldShowBonusComponent">
              <InterestFormBonus
                :form-data="formData"
                :setting-name="'设置利率'"
                :type="'acc'"
                :step="0.1"
                :previous-bonus-custom-rate="Number(accRate)"
                :max-bonus-custom-rate="5"
                @update="data => updateAccRate(data)"
              />
            </template>
          </div>
        </li>
      </ul>
    </section>
    <InterestFormRate
      v-model="isShowRatePopup"
      :form-data="formData"
      :has-custom-rate="hasCustomRate"
      :previous-rate="cachePreviousRate"
      @update="data => $emit('update', data)"
    />
  </div>
</template>
<script>
import { URL_PARAM } from "common/utils/variables";
import { DISPLAY_TYPE_OPTIONS } from '../constant'
import InterestFormRate from './interest-form-rate.vue'
import InterestFormBonus from './interest-form-bonus.vue';
import { isNuoYa } from 'base/config'

const { shareFrom, isShareFormWeApp } = URL_PARAM
export default {
  components: {
    InterestFormRate,
    InterestFormBonus,
  },
  props: {
    isScreenCaptureShow: Boolean,
    settingStore: {
      type: Object,
      required: true,
      default: () => ({})
    },
    formData: {
      type: Object
    },
    interestDemoOptions: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      cachePreviousRate: null,
      isApp: (window.appBridge && window.appBridge.isApp()) || isNuoYa,
      isShowHeaderFixed: false,
      settingName:'设置实现率',
      DISPLAY_TYPE_OPTIONS,
      bonusCustomRate:null,
      isShowBonusSetting:true,
    }
  },
  computed: {
    isTerminalC(){
      return isShareFormWeApp || shareFrom
    },
    isShowRatePopup () {
      return this.formData.formValues.isShowRatePopup
    },
    isShowBonusPopup() {
      return this.formData.formValues.isShowBonusPopup
    },
    maxBonusCustomRate() {
      // return this.formData.formValues.maxBonusCustomRate
      return 200
    },

    hasCustomRate () {
      const rateItem = this.interestDemoOptions.find(o => o.key === 'rate')
      return rateItem && rateItem.hasCustomRate
    },
    isShowSettingButton () {
      const { isApp, appPlatform, params } = this
      return (isApp || ['WXMP', 'WXMP_BXZ', 'WECHAT_GAOKE', 'H5_BXZ'].includes(appPlatform)) && shareFrom !== 'mpH5ShareBtn' && !params.isForPresentation
    },
    hasBonusTake() {
      return this.interestDemoOptions.some(o => o.key === 'bonusTake')
    },
    hasPensionTake() {
      return this.interestDemoOptions.some(o => o.key === 'pensionTake')
    },
    shouldShowBonusComponent() {
      const { formValues } = this.formData
      const hasBonusAccumulation = formValues.bonusTake === 'bonus_acc'
      const hasPensionAccumulation = formValues.pensionTake === 'annuity_acc'
      return this.hasBonusTake && this.hasPensionTake
        ? (hasBonusAccumulation || hasPensionAccumulation)
        : (this.hasBonusTake && hasBonusAccumulation) || (this.hasPensionTake && hasPensionAccumulation)
    },
    accRate(){
      return this.formData.formValues.accRate || null
    },

  },
  watch: {
    'formData.formValues': {
      deep: true,
      immediate: true,
      handler (v) {
        this.bonusCustomRate = v.bonusCustomRate ? Number(v.bonusCustomRate) : null
        this.handleShowBonusSetting(v)
      }
    },
  },
  mounted () {
    const self = this
    window.addEventListener('scroll', () => {
      self.showHeaderFixed()
    })
    document.addEventListener('touchmove', () => {
      self.showHeaderFixed()
    })
    self.showHeaderFixed()

    console.log('interestDemo mounted, isShowSettingButton:' + this.isShowSettingButton + ', isnuoya:' + isNuoYa)
  },
  methods: {
    showHeaderFixed() {
      const fixedDom = document.querySelector('#interestDemo')
      const rect = fixedDom && fixedDom.getBoundingClientRect()
      if (!rect) {
        return
      }
      this.isShowHeaderFixed = (rect.y + 30) <= 0 && (rect.bottom - 30) >= 0
    },
    isActiveOption (item, option) {
      const { settingStore, formData } = this
      if (['activeProductId'].includes(item.key) && option.value === settingStore[item.key]) {
        return true
      }
      if (['rate'].includes(item.key)) {
        const { rateIndex } = formData.formValues
        return option.index === rateIndex || (rateIndex === -1 && Math.abs(formData.customRate - option.value) < 1e-5)
      }
      if (['addAndTakeData', 'drawData'].includes(item.key)) {
        return option.value === (item.key === 'drawData' ? formData.formValues.drawFlag : formData.formValues.addAndTakeFlag)
      }
      return option.value === formData.formValues[item.key]
    },
    onClickItem(item, option) {
      const self = this
      if (item.key === 'rate') {
        self.$emit('update', {
          rateIndex: option.index,
          rate: option.value
        })
      } else if (['addAndTakeData', 'drawData'].includes(item.key)) {
        self.$emit('update', {
          [item.key === 'drawData' ? 'drawFlag' : 'addAndTakeFlag']: option.value
        })
      } else {
        self.$emit('update', {
          [item.key]: option.value
        })
      }
    },
    openItemSetting (item) {
      const self = this
      if (item.key === 'rate') {
        self.cachePreviousRate = self.formData.formValues.rate ? Number(self.formData.formValues.rate) : null
        self.$emit('update', {
          isShowRatePopup: true
        })
      } else if (item.key === 'bonus') {
        self.$emit('update', {
          isShowBonusPopup: true
        })
      } else if (['addAndTakeData', 'drawData'].includes(item.key)) {
        self.$emit('open-add-and-take', item)
      }
    },
    updateBonusRate(bonusItem, data) {
      this.bonusCustomRate=data.bonusCustomRate
      this.$emit('update', {
        bonusCustomRate: Number(data.bonusCustomRate > 200 ? 200 : data.bonusCustomRate)
      })
      bonusItem.options[bonusItem.options.length-1].description = `红利实现率 ${data.bonusCustomRate > 200 ? 200 : data.bonusCustomRate}%`
    },
    updateAccRate(data) {
      const accRateValue = data.accRate > 0.05 ? 0.05 : data.accRate
      this.$emit('update', {
        accRate: Number(accRateValue)
      })
    },
    getBonusItem() {
      return this.interestDemoOptions.find(o => o.key === 'bonus') || {}
    },
    handleShowBonusSetting(v){
      const bonusIndex=this.interestDemoOptions.find(item=>item.key==='bonus')
      if(!!bonusIndex&&bonusIndex.options.length>0){
        const rateIndex=bonusIndex.options.find(o=>o.value==="PSUDO_OPTION_CUSTOM_RATE")
        if(!!rateIndex && (isShareFormWeApp || shareFrom)){
          if (v.bonusCustomRate === null || v.bonusCustomRate === undefined || Number(v.bonusCustomRate) === 100) {
            rateIndex.hiddenFlag=true
            this.isShowBonusSetting=false
          }else{
            rateIndex.hiddenFlag=false
            this.isShowBonusSetting=true
          }
          this.$emit('hideBonus',this.isShowBonusSetting)
        }
      }
    },
  }
}
</script>
<style lang="postcss">
@import './interest-form.css';
</style>
